import { render, staticRenderFns } from "./dustbinDetail.vue?vue&type=template&id=1eccad9a&scoped=true&"
import script from "./dustbinDetail.vue?vue&type=script&lang=js&"
export * from "./dustbinDetail.vue?vue&type=script&lang=js&"
import style0 from "./dustbinDetail.vue?vue&type=style&index=0&id=1eccad9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eccad9a",
  null
  
)

export default component.exports